// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/a854b638952c26e15f04.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"7a0e4b2e31e86324f109","140":"3849ad1c0e27a2f722f9","141":"b578488fdcea02e5b308"}[chunkId] + ".chunk.js";
};